import ResponsiveTable from '../ReusableComponents/ResponsiveTable';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { jsPDF } from 'jspdf';
import Request from '../../Request';
import DefaultButton from '../ReusableComponents/DefaultButton';
import withTrainingAdminShell from '../ReusableComponents/TrainingAdminShell';

export function DashboardTreinamento() {
    const { id } = useParams();
    const [data, setData] = useState(null), [error, setError] = useState(''), [loading, setLoading] = useState(true);
    useEffect(() => {
        let active = true;
        Request.Get(`treinamento/fiscal/${id}`).then(response => {
            if (!active) return;
            if (!response?.users) throw new Error(response?.errors?.error || 'Não foi possível carregar o relatório.');
            setData(response);
        }).catch(e => { if (active) setError(e.message); }).finally(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, [id]);
    const users = data?.users || [];
    const finished = users.filter(user => user.concluido).length;
    const started = users.filter(user => !user.concluido && user.progress?.completed > 0).length;
    const downloadPDF = () => {
        const pdf = new jsPDF();
        pdf.setFontSize(16); pdf.text(data.training.nome, 14, 20);
        pdf.setFontSize(10); let y = 32;
        users.forEach(user => {
            const lines = pdf.splitTextToSize(`${user.name} — ${user.progress.completed}/${user.progress.total} conteúdos — ${user.concluido ? 'Concluído' : 'Pendente'}`, 180);
            if (y + lines.length * 6 > 280) { pdf.addPage(); y = 20; }
            pdf.text(lines, 14, y); y += lines.length * 6 + 4;
        });
        pdf.save('relatorio-treinamento.pdf');
    };
    return <div className="card"><div className="card-body">
        <div className="training-admin-preview-actions"><div><h2 className="header-title">{data?.training?.nome || 'Relatório do treinamento'}</h2><p>{data?.instituicao?.name}</p></div><DefaultButton text="Voltar" bg="secondary" to={data?.instituicao?.id ? `/instituicao/show/${data.instituicao.id}?tab=5` : '/treinamentos'} /></div>
        {loading && <p role="status">Carregando relatório…</p>}
        {error && <div className="alert alert-danger" role="alert">{error}</div>}
        {data && <>
            <div className="training-admin-report-totals"><div><span>Fiscais vinculados</span><strong>{users.length}</strong></div><div><span>Concluídos</span><strong>{finished}</strong></div><div><span>Em andamento</span><strong>{started}</strong></div></div>
            <div className="table-responsive"><ResponsiveTable className="table"><thead><tr><th>Fiscal</th><th>Conteúdos concluídos</th><th>Progresso</th><th>Status</th></tr></thead><tbody>{users.map(user => <tr key={user.id}><td>{user.name}<small className="d-block text-muted">{user.email}</small></td><td>{user.progress.completed} de {user.progress.total}</td><td>{user.progress.total ? Math.round(user.progress.completed * 100 / user.progress.total) : 0}%</td><td><span className={`badge ${user.concluido ? 'bg-success' : user.progress.completed ? 'bg-primary' : 'bg-warning text-dark'}`}>{user.concluido ? 'Concluído' : user.progress.completed ? 'Em andamento' : 'Não iniciado'}</span></td></tr>)}</tbody></ResponsiveTable></div>
            {!users.length && <p>Nenhum fiscal vinculado a este treinamento.</p>}
            <button className="btn btn-primary" type="button" disabled={!users.length} onClick={downloadPDF}>Baixar relatório em PDF</button>
        </>}
    </div></div>;
}
export default withTrainingAdminShell(DashboardTreinamento, 'trainings');
